import React, { useState } from 'react';
import { IProgressiveLoadingImage } from '../../../interfaces/image/image';

const ProgressiveLoadingImage = ({ lowResUrl, highResUrl, token, altText} : IProgressiveLoadingImage) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <>
    {/* this image will appear with the low res image */}
      <img
        className={`progressive-loading-image-low-res ${loaded && 'is-loaded'}`}
        src={token ? `${lowResUrl}?width=160&height=160&rmode=min&quality=50&access_token=${token}` : `${lowResUrl}?width=160&height=160&rmode=min&quality=50`}
        alt={altText || ""}
       />

    {/* this high res image will appear in the place of the other when it has loaded */}
      <img
        className={`progressive-loading-image-high-res ${loaded && 'display-high-res'}`}
        src={token ? `${highResUrl}?width=1000&height=1000&access_token=${token}`: `${highResUrl}?width=1000&height=1000`}
        alt={altText || ""}
        onLoad={() => setLoaded(true)}
      />
    </>
  );
};

export default ProgressiveLoadingImage;